import { CheckCircle, CircleNotch, Circle, WarningCircle } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const ICONS = {
  done: { Icon: CheckCircle, color: "#00E559", weight: "fill" },
  running: { Icon: CircleNotch, color: "#FF5500", weight: "bold" },
  error: { Icon: WarningCircle, color: "#FF3333", weight: "fill" },
  pending: { Icon: Circle, color: "#52525b", weight: "regular" },
};

export default function StageTracker({ stages }) {
  return (
    <div className="border border-border">
      {stages.map((s, i) => {
        const meta = ICONS[s.status] || ICONS.pending;
        const { Icon } = meta;
        return (
          <motion.div key={s.key}
            initial={{ opacity: 0, x: -6 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.04 }}
            data-testid={`stage-${s.key}`}
            className={`flex items-start gap-4 p-4 border-b border-border last:border-b-0 ${s.status === "running" ? "stage-active bg-[#0e1a10]" : "bg-[#18181B]"}`}>
            <div className="pt-0.5">
              <Icon size={22} weight={meta.weight} color={meta.color} className={s.status === "running" ? "animate-spin" : ""} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-3">
                <div className="font-mono text-sm">
                  <span className="text-muted-foreground mr-2">{String(i + 1).padStart(2, "0")}</span>
                  {s.label}
                </div>
                <div className="flex items-center gap-4 font-mono text-xs shrink-0">
                  <span className="text-muted-foreground">{s.duration_s != null ? `${s.duration_s}s` : "—"}</span>
                  <span style={{ color: "#00E559" }}>{s.cost != null ? `$${s.cost}` : "—"}</span>
                  <span className="overline" style={{ color: meta.color, fontSize: "0.55rem" }}>{s.status}</span>
                </div>
              </div>
              {s.detail && <div className="text-xs text-muted-foreground mt-1.5 leading-relaxed" data-testid={`stage-${s.key}-detail`}>{s.detail}</div>}
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
